import React from 'react';
import {Tab} from '../../../shared/elements/tab/Tab';
import {map as _map} from 'lodash';

export default function CustomerList({customers, setSelected, selected}) {
    return (
        <Tab stacked>
            {_map(customers, (customer, index) => (
                <Tab.Option
                    key={index}
                    onClick={() => {
                        setSelected(customer);
                    }}
                    selected={selected && selected.customerId === customer.customerId}
                >
                    {customer.name}
                </Tab.Option>
            ))}
        </Tab>
    );
}
